import React, { useEffect } from "react";
import PasswordInput from "./PasswordInput";
import SocialIcons from "./SocialIcons";
import RememberMe from "./RememberMe";
import { useRealtimeValidation } from "../../hooks/useRealtimeValidation";

const AUTH_FIELDS_CONFIG = {
  signup: [
    { name: "last_name", type: "text", placeholder: "Nom", component: "input" },
    { name: "first_name", type: "text", placeholder: "Prenom", component: "input" },
    { name: "email", type: "email", placeholder: "Email", component: "input" },
    { name: "password", type: "password", placeholder: "Mot de passe", component: "password" },
    { name: "confpassword", type: "password", placeholder: "Confirme le mot de passe", component: "password" },
    { name: "rememberMe", component: "rememberMe" }
  ],
  signin: [
    { name: "email", type: "email", placeholder: "Email", component: "input" },
    { name: "password", type: "password", placeholder: "Mot de passe", component: "password" },
    { name: "rememberMe", component: "rememberMe" }
  ]
};

const AuthForm = ({ mode, data, onChange, error, loading, onSubmit, showSocial = true, message = "", onForgotPassword }) => {
  const fields = AUTH_FIELDS_CONFIG[mode] || [];
  const { fieldErrors, updateFieldError } = useRealtimeValidation(mode);

  // Gestion du changement avec validation en temps réel
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === "checkbox" ? checked : value;
    
    // Appeler le onChange original
    onChange(e);
    
    // Valider le champ en temps réel (uniquement pour les champs de texte)
    if (type !== "checkbox") {
      updateFieldError(name, inputValue, data);
    }
  };

  const renderField = (field) => {
    const hasError = fieldErrors[field.name];

    if (field.component === "password") {
      return (
        <div key={field.name} className="field-wrapper">
          <PasswordInput
            name={field.name}
            placeholder={field.placeholder}
            value={data[field.name] || ""}
            onChange={handleInputChange}
            autoComplete="new-password"
            invalid={hasError ? "true" : undefined}
            data-error={hasError || undefined}
          />
          {hasError && <span className="field-error-message">{hasError}</span>}
        </div>
      );
    }

    if (field.component === "rememberMe") {
      return (
        <RememberMe
          key={field.name}
          checked={data[field.name] || false}
          onChange={onChange}
        />
      );
    }

    return (
      <div key={field.name} className="field-wrapper">
        <input
          type={field.type}
          name={field.name}
          placeholder={field.placeholder}
          value={data[field.name] || ""}
          onChange={handleInputChange}
          invalid={hasError ? "true" : undefined}
          data-error={hasError || undefined}
        />
        {hasError && <span className="field-error-message">{hasError}</span>}
      </div>
    );
  };

  return (
    <>
      <h1>{mode === "signin" ? "Connexion" : "Créer un compte"}</h1>
      {showSocial && <SocialIcons />}
      <span className="textConexionMessage">{message}</span>

      {fields.map(field => renderField(field))}

      {error && <p style={{ color: "red" }}>{error}</p>}
      <button type="button" onClick={onSubmit} disabled={loading}>
        {loading ? "..." : mode === "signin" ? "Connexion" : "Inscription"}
      </button>

      {mode === "signin" && onForgotPassword && (
        <button
          type="button"
          className="btnForgotPassword"
          onClick={onForgotPassword}
          style={{
            marginTop: "10px",
            background: "none",
            border: "none",
            color: "var(--text-rose-cuivre)",
            cursor: "pointer",
            textDecoration: "underline",
            fontSize: "14px"
          }}
        >
          Mot de passe oublié ?
        </button>
      )}
    </>
  );
};

export default AuthForm;
